<div
  class="modal-header"
  hsDraggable="modal-dialog"
  hsResizable="modal-content"
>
  <h4 class="modal-title">{{ title }} {{ accountId }}</h4>
  <button
    nf-icon-button
    icon="close"
    class="btn-bare"
    (click)="activeModal.dismiss()"
  >
    Close
  </button>
</div>
<div class="modal-body" hsDraggable="modal-dialog">
  <ng-container>
    <nf-table-layout
      class="trade-entry-table"
      [autoResizeGrid]="false"
      hideTitle
      [isSectionTitle]="false"
      [gridOptions]="gridOptions"
      [data]="rowData"
      hideSearch
      hideClearAll
    >
      <nf-table-properties [currentProperties]="propertiesTitle">
        <div class="properties-form-group">
          <label
            >Display Advanced Rows
            <nf-toggle
              [formControl]="displayAdvancedRows"
              (change)="toggleRows()"
              states="true"
            ></nf-toggle
          ></label>
          <label
            >Display Dynamic Rows
            <nf-toggle
              [formControl]="displayDynamicRows"
              (change)="toggleDynamicRows()"
              states="true"
            ></nf-toggle
          ></label>
        </div>
      </nf-table-properties>
    </nf-table-layout>
    <ngb-accordion
      *ngIf="
        (transactionMatchesCustody && transactionMatchesCustody.length > 1) ||
        (transactionMatchesTrading && transactionMatchesTrading.length > 1)
      "
      [destroyOnHide]="false"
    >
      <ngb-panel title="Matches">
        <ng-template ngbPanelContent>
          <p
            class="underlined-sub-heading"
            *ngIf="
              transactionMatchesCustody && transactionMatchesCustody.length > 1
            "
          >
            Custody
          </p>
          <hs-trade-matches
            *ngIf="
              transactionMatchesCustody && transactionMatchesCustody.length > 1
            "
            [matches]="transactionMatchesCustody"
            [counterPartyList]="counterPartyList"
            [applyHPL]="applyHPL"
            [accountDisplayName]="accountNameAgg ?? accountName"
            [security]="security"
            (matchCellDoubleClick)="matchCellDoubleClick($event)"
          ></hs-trade-matches>
          <p
            class="underlined-sub-heading"
            *ngIf="
              transactionMatchesTrading && transactionMatchesTrading.length > 1
            "
          >
            Trading
          </p>
          <hs-trade-matches
            *ngIf="
              transactionMatchesTrading && transactionMatchesTrading.length > 1
            "
            [matches]="transactionMatchesTrading"
            [applyHPL]="applyHPL"
            [counterPartyList]="counterPartyList"
            [accountDisplayName]="accountNameAgg ?? accountName"
            [security]="security"
            (matchCellDoubleClick)="matchCellDoubleClick($event)"
          ></hs-trade-matches>
        </ng-template>
      </ngb-panel>
    </ngb-accordion>
    <nf-form-control
      label="Notes"
      [customErrorMessages]="getFieldValidatorFormatter('transactionNote')"
      [warnings]="noteWarning"
      class="notes-control"
    >
      <textarea
        id="notesText"
        class="form-control"
        [formControl]="note"
        (focus)="disableGridFocus()"
        rows="3"
      ></textarea>
    </nf-form-control>

    <nf-form-control
      class="forbidden-control"
      label="Missing Permissions : "
      [customErrorMessages]="getFieldValidatorFormatter('forbiddenErrors')"
      [hidden]="!forbiddenErrors.errors"
    >
      <p id="forbiddenText" class="form-control">{{ forbiddenErrors.value }}</p>
    </nf-form-control>
  </ng-container>
  <hs-loader
    class="{{ !transactionLoaded || formSubmitting ? 'active' : '' }}"
    [loading]="!transactionLoaded || formSubmitting"
    [label]="loadingText"
    [errorLabel]="errorText"
    [showText]="!transactionLoaded || formSubmitting"
  ></hs-loader
  ><hs-dialog-error-details
    [errorHeader]="errorHeader"
    [errorDetails]="errorDetails"
  ></hs-dialog-error-details>
</div>
<div class="modal-footer d-flex align-items-center" hsDraggable="modal-dialog">
  <div class="mr-3">
    <nf-checkbox
      [formControl]="clearTransaction"
      label="Clear Transaction"
    ></nf-checkbox>
  </div>
  <div class="mr-3">
    <nf-checkbox
      [formControl]="reprocessTransfers"
      label="Reprocess Downstream Transfers"
    ></nf-checkbox>
  </div>
  <div class="flex-grow-1 text-right">
    <span *ngIf="isValidating" class="mdi mdi-loading">validating..</span>
    <button
      [disabled]="!isPriceRequestEnabled()"
      nf-button="secondary"
      (click)="loadPriceModal()"
    >
      Request Calculated Price
    </button>
    <button nf-button="cancel" (click)="activeModal.dismiss()"></button>
    <button
      *ngIf="!transInput?.readOnly"
      nf-button="primary"
      [disabled]="!isDataValid || this.isCellEditing || !transactionLoaded"
      (click)="save()"
    >
      Save
    </button>
  </div>
</div>
